import { PropsWithChildren, ReactElement } from 'react';

import LogoWhite from '@/assets/ic_gdt-white.svg';
import { CardSheetLayout, NavBar } from '@/components';
import { KeysOf } from '@/types';
import { cn, BACKGROUND_CLASS_SECTION_APP } from '@/utils';

type Props = PropsWithChildren<{
  title?: string | ReactElement;
  titleNavbar?: string;
  className?: string;
  context?: KeysOf<typeof BACKGROUND_CLASS_SECTION_APP>;
}>;

export const RegistrationLayout = ({
  children,
  title,
  titleNavbar,
  className,
  context = 'register',
}: Props) => {
  const isWelcome = context?.includes('welcome');

  if (context === 'nameTeam' || isWelcome) {
    return (
      <CardSheetLayout
        showFooter
        bgClassName={
          BACKGROUND_CLASS_SECTION_APP[context] ??
          BACKGROUND_CLASS_SECTION_APP.register
        }
        bgLabel="jugador de futbol a punto de patear una pelota"
        cardClassName={cn('pb-8 lg:pb-8 lg:pt-10', {
          'lg:pt-20 lg:pb-16':
            BACKGROUND_CLASS_SECTION_APP[context] ===
            BACKGROUND_CLASS_SECTION_APP.nameTeam,
          'lg:pb-10 lg:pt-12':
            BACKGROUND_CLASS_SECTION_APP[context] ===
            BACKGROUND_CLASS_SECTION_APP.welcome_2,
        })}
        title={title}
      >
        {children}
      </CardSheetLayout>
    );
  }

  return (
    <NavBar
      mobile={{
        leftContent: {
          displayLogo: true,
        },
        centerContent: {
          title: titleNavbar,
        },
      }}
    >
      <main className="flex-1 flex">
        <div
          aria-label="persona amarrandose los zapatos con un balon de futbol"
          className={cn(
            BACKGROUND_CLASS_SECTION_APP[context] ??
              BACKGROUND_CLASS_SECTION_APP.register,
            'hidden lg:flex lg:items-center lg:justify-center relative flex-1'
          )}
        >
          <figure className="relative z-[1]">
            <img alt="logo de grandt" className="h-auto w-32" src={LogoWhite} />
          </figure>
        </div>
        <section
          className={cn(
            'flex-auto ml-auto lg:max-w-[46rem] lg:bg-white bg-gdt-gray-7 py-6 lg:py-14 px-6 lg:px-20',
            className
          )}
        >
          {children}
        </section>
      </main>
    </NavBar>
  );
};
